module.exports = __webpack_public_path__ + "img/accsessdata.9dc3bc12.svg";